import { useTranslation } from "react-i18next";
import { Tabs, Tab } from "barte-design-system";
import { Skeleton } from "@shared/components";

import type { PaymentMethodTabsProps } from "./payment-method-tabs.type";
import styles from "./payment-method-tabs.module.css";

export const PaymentMethodTabs = ({
    activeMethod,
    onMethodChange,
    isLoading
}: PaymentMethodTabsProps) => {
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className={styles["repass-container"]}>
                <Skeleton width="4.5rem" height="1.2rem" />
                <div className={styles['skeleton-tabs']}>
                    <Skeleton width="4rem" height="2rem" />
                    <Skeleton width="4rem" height="2rem" />
                    <Skeleton width="4rem" height="2rem" />
                </div>
            </div>
        );
    }

    return (
        <div className={styles["repass-container"]}>
            <span className={styles.label}>{t("backoffice.pageModalCompanyPlanPaymentTypeLabel")}</span>
            <Tabs>
                {(["online", "pos", "tap"] as const).map((method) => (
                    <Tab
                        key={method}
                        active={activeMethod === method}
                        onClick={() => onMethodChange(method)}
                    >
                        {t(`backoffice.pageModalCompanyPlanPaymentType${method.charAt(0).toUpperCase() + method.slice(1)}`)}
                    </Tab>
                ))}
            </Tabs>
        </div>
    );
};
